var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1494,
    height: 791,
    viewBox: "0 0 1494 791",
    role: "img",
    "aria-labelledby": titleId,
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, "PLS") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.96818,0,0,1.96825,-0.0531409,-0.499794)"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M351.965,377.746L26.543,377.746C12.301,377.668 0.633,366.422 0.027,352.195L0.027,26.77C0.211,12.203 11.977,0.441 26.543,0.254L351.965,0.254C366.344,0.254 378,11.91 378,26.289L378,351.711C378,366.09 366.344,377.746 351.965,377.746Z",
    style: {
      fill: "rgb(40,86,128)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.543,351.711C26.387,351.711 26.14,351.453 26.062,351.297L26.062,27.406C26.062,26.977 26.25,26.57 26.574,26.289L351.965,26.289L351.965,351.711L26.543,351.711Z",
    style: {
      fill: "rgb(59,151,211)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.965,358.219L26.543,358.219C22.949,358.219 20.035,355.305 20.035,351.711L20.035,26.289C20.035,22.695 22.949,19.781 26.543,19.781L351.965,19.781C355.562,19.781 358.473,22.695 358.473,26.289L358.473,351.711C358.473,355.305 355.562,358.219 351.965,358.219ZM33.051,345.203L345.457,345.203L345.457,32.797L33.051,32.797L33.051,345.203Z",
    style: {
      fill: "rgb(236,240,241)",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.219,299.645L163.219,215.035L203.332,215.035C242.461,215.492 275.59,186.273 280.035,147.398C282.043,126.395 275.102,105.52 260.918,89.898C246.734,74.281 226.625,65.363 205.527,65.34L137.188,65.34C129.996,65.34 124.168,71.168 124.168,78.355L124.168,299.645C124.168,306.832 129.996,312.66 137.188,312.66L150.203,312.66C157.391,312.66 163.219,306.832 163.219,299.645ZM205.527,175.984L163.219,175.984L163.219,104.391L205.527,104.391C225.297,104.391 241.32,120.418 241.32,140.188C241.32,159.957 225.297,175.984 205.527,175.984Z",
    style: {
      fill: "white",
      fillRule: "nonzero"
    }
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M890 190 V576 H1035",
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1390 207 C1280 143 1163 191 1163 281 C1163 383 1390 357 1390 474 C1390 570 1265 613 1168 553",
    fill: "none",
    stroke: "#10b981",
    strokeWidth: 92,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c815ca5012e7d35a21e471f7af34b1cf.svg";
export { ForwardRef as ReactComponent };